import script from "./Goal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Goal.vue?vue&type=script&setup=true&lang=ts"

import "./Goal.vue?vue&type=style&index=0&id=110c3194&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110c3194"]])